package xyz.malefic.kanman.client.api

import xyz.malefic.kanman.client.api.util.deleteAuth
import xyz.malefic.kanman.client.api.util.getAuth
import xyz.malefic.kanman.client.api.util.patchAuth
import xyz.malefic.kanman.client.api.util.postAuth
import xyz.malefic.kanman.shared.data.model.BoardDetailsModel
import xyz.malefic.kanman.shared.data.model.BoardEventModel
import xyz.malefic.kanman.shared.data.model.BoardResponseModel
import xyz.malefic.kanman.shared.data.model.BoardSummaryModel
import xyz.malefic.kanman.shared.data.model.Column
import xyz.malefic.kanman.shared.data.model.PaginatedResponse
import xyz.malefic.kanman.shared.data.model.Role
import xyz.malefic.kanman.shared.data.model.RoleUpdateRequest
import xyz.malefic.kanman.shared.data.model.StickyNoteModel
import xyz.malefic.kanman.shared.data.model.UserSummaryModel
import kotlin.uuid.Uuid

suspend fun getPublicBoards(
    page: Int = 1,
    limit: Int = 50,
) = getAuth<PaginatedResponse<BoardSummaryModel>>("boards?page=$page&limit=$limit")

suspend fun getBoard(id: Uuid) = getAuth<BoardResponseModel>("boards/$id")

suspend fun getBoardStickies(
    id: Uuid,
    column: Column,
) = getAuth<List<StickyNoteModel>>("boards/$id?column=$column")

suspend fun createBoard(board: BoardDetailsModel) = postAuth<_, BoardResponseModel>("boards", board)

suspend fun updateBoard(
    id: Uuid,
    board: BoardDetailsModel,
) = patchAuth<_>("boards/$id", board)

suspend fun deleteBoard(id: Uuid) = deleteAuth("boards/$id")

suspend fun boardHistory(
    id: Uuid,
    page: Int = 1,
    limit: Int = 50,
) = getAuth<PaginatedResponse<BoardEventModel>>("boards/$id/history?page=$page&limit=$limit")

suspend fun boardUsers(id: Uuid) = getAuth<List<UserSummaryModel>>("boards/$id/users")

suspend fun joinBoard(id: Uuid) = postAuth<BoardResponseModel>("boards/$id/users")

suspend fun updateRole(
    boardId: Uuid,
    userId: Uuid,
    role: Role,
) = patchAuth<RoleUpdateRequest>("boards/$boardId/users/$userId", RoleUpdateRequest(role))

suspend fun kick(
    boardId: Uuid,
    userId: Uuid,
) = deleteAuth("boards/$boardId/users/$userId")
